import RecordingController from '../RecordingController';

export default {
    namespaced: true,

    state: () => ({
        recordingController: new RecordingController(),
    }),

    actions: {
        ForceComplete({state}, recordingId) {
            state.recordingController.forceComplete(recordingId);
        },
    },
}